import ScalarCardFooter_vue_vue_type_script_setup_true_lang_default from "./ScalarCardFooter.vue_vue_type_script_setup_true_lang.js";
//#region src/components/ScalarCard/ScalarCardFooter.vue
var ScalarCardFooter_default = ScalarCardFooter_vue_vue_type_script_setup_true_lang_default;
//#endregion
export { ScalarCardFooter_default as default };

//# sourceMappingURL=ScalarCardFooter.vue.js.map